import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import {
  EAdvertiserReportPageType,
  IError,
  IReportingTableResponse,
  ITotalItems,
} from '@unfoldrtech/portal-mic'
import { coreAPI } from '../services/coreAPI'
import {
  generateCorrelationId,
  getTZOffset,
  getTimezone,
} from '../utils/helpers'
import {
  TPPAdvertiserId,
  TPPRetailerId,
  TReportingFilters,
} from '../models/types'
import { IReportPageTypes } from '../models/interfaces'

export default function useGetAdvertiserReportsTable({
  advertiserId,
  retailerId,
  advertiserReportPageType:
    reportPageType = EAdvertiserReportPageType.Campaigns,
  campaignIds,
  adGroupIds,
  categoryIds,
  keywordIds,
  pageIds,
  positionIds,
  productIds,
  channelType,
  inventoryType,
  sortBy,
  sortOrder,
  pageLimit,
  pageOffset,
  timeWindow,
  endDate,
  startDate,
  tzOffset,
  tzZone,
  enabled = true,
  suspense = true,
  creativeIds,
}: {
  enabled?: boolean
  suspense?: boolean
} & TReportingFilters &
  TPPRetailerId &
  TPPAdvertiserId &
  IReportPageTypes): UseQueryResult<
  AxiosResponse<ITotalItems & IReportingTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportTable_${advertiserId}_${retailerId}_${reportPageType}_${
    channelType || ''
  }_${inventoryType || ''}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    ({ queryKey }) => {
      const filters = queryKey[1] || {}
      const { start, end } = filters as { start: string; end: string }

      return coreAPI
        .advertiserReporting()
        .getAdvertiserReportTable(
          advertiserId,
          reportPageType,
          generateCorrelationId(),
          retailerId,
          campaignIds,
          adGroupIds,
          categoryIds,
          creativeIds,
          keywordIds,
          pageIds,
          positionIds,
          productIds,
          undefined,
          channelType,
          sortBy,
          pageLimit,
          pageOffset,
          timeWindow,
          start,
          end,
          sortOrder,
          inventoryType,
          tzOffset || getTZOffset(endDate),
          tzZone || getTimezone()
        )
    },
    { suspense, enabled }
  )
}
